// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1Ju6W","header":"PatientBlock_header__3w8Lg","label":"PatientBlock_label__BihrS","option":"PatientBlock_option__2_69A"};